import React, { useCallback, useContext } from 'react'
import { useSelector } from 'react-redux'
import { getSelectedTransitionsByGroup } from 'selectors'
import { useAction } from 'hooks'
import * as Actions from '~/actions'
import { TranslationContext } from '~/contexts/TranslationContext'
import TransitionDurationField from '../../FormFields/TransitionDurationField'
import Form from '../../BaseAssetSettingsForm'
import { TransitionAsset } from '../../../../models/Asset'


export default function TransitionAssetSettingsForm(props) {
  const {
    /** @type {Assets.TransitionAsset} */
    asset,
    onChange,
    ...rest
  } = props

  // TODO: implement applyToAll logic for transitions. Probably
  // it will require to move applyToAll to global store
  const selectedTransitions = useSelector(getSelectedTransitionsByGroup)
  const onSelectSame = useAction(Actions.layer.selectAsset, asset.id,
    { selectSame: true, selectedType: asset.type })
  const isMixedType = selectedTransitions[asset.type] > 0
    && selectedTransitions[asset.type] !== selectedTransitions.count
  const { t } = useContext(TranslationContext)

  const {
    onChangeDuration,
    onChangeType,
  } = useTransitionAssetFormHandlers(asset, onChange)

  return (
    <Form
      {...rest}
      selectedType={asset.type}
      asset={asset}
      onSelectSame={onSelectSame}
      title={t('TRANSITION_FORM_TITLE_SETTINGS_TRANSITION')}
      description={isMixedType ? 'Mixed' : t(TransitionAsset.getTranslationKey(asset.type))}
      selectedAssetsByType={selectedTransitions}
      isMixedType={isMixedType}
      hideScrollbar
    >
      <TransitionDurationField
        onChangeDuration={onChangeDuration}
        onChangeType={onChangeType}
        type={asset.type}
        transition={asset}
        value={asset.duration}
      />
    </Form>
  )
}

function useTransitionAssetFormHandlers(asset, update) {
  return {
    onChangeDuration: useCallback(duration => update({ duration }),
      [ update ]),
    onChangeType: useCallback(type => update({ type }),
      [ update ]),
  }
}
